import { compact, flow, get, has, isEmpty, map, noop, overEvery, size, times, inRange, isEqual } from 'lodash/fp'
import {
  addFileProps,
  createCCPADefaultValue,
  sendApplication,
  setAppValue,
  setDefaultDCA,
  updateConsentDCATerms,
  updateConsentEdaTerms,
  updateReceipt,
  validateApplication,
} from 'e-submission/apps/actions'
import {
  canSubmit,
  getAllAdditionalDocument,
  getAllCreditCardRelationshipDocument,
  isCreditCardRelationshipDocumentNotEmpty,
  getFiles,
  getFileWithName,
  getPreviewMultipleDoc,
  isSectionValid,
  isConsentEdaComplete,
  isEDAViewFormOnly,
  getAIUWPolicyStatus,
  getAIUW,
  getCurrentApp,
  isAIUWFinished,
  isCheckAccountDCA,
  getInsuredHeightAndWeight,
} from 'e-submission/apps/selectors'
import {
  createField,
  createSection,
  createSectionCreator,
  calculateBMI,
} from 'e-submission/domain/data-model/form/utils'
import {
  allowToSubmitWithoutPayment,
  hasATP,
  isSelectedToPayNow,
  getDCA,
  isATPSubmitted,
  isATPPaid,
  isFormTypeDA,
  isFormTypeEDA,
  isAcceptConsentDA,
  isEDAConsent,
  isCheckStatusEDA,
  isDCASigned,
  isShowDCAForm,
  isShowingBayEdaQrCode,
  isShowDCASelected,
  isDCASelected,
  isRemoteSelling,
  isCreditCardRelationshipTier1,
  isFinishCreditCardPaymentSection,
  isSignedCreditCardPaymentSection,
  isPayerOther,
  isSignedEcbr,
  hasEvidenceUpload,
  getSelectedReceiptType,
  getReceiptDocumentType,
  getReceiptNo,
  isAppEligibleToDoCCPA,
  isCCPAStatusCompleted,
  isCCPAStatusError,
  isQuickQuoteModelFactorMonthly,
  getSelectedReceiptEcbrStatus,
  isDCAConsent,
  isAcceptConsentDCA,
  isMRTACategory,
} from 'e-submission/domain/data-model/form/selectors'
import { DOCUMENT_TYPE } from 'e-submission/domain/data-model/constants'
import { ATPSection } from 'e-submission/domain/data-model/payment/ATPSection'
import { buildCCPADefaultValue, CCPASection } from 'e-submission/domain/data-model/payment/CCPASection'
import { ConsentSection } from 'e-submission/domain/data-model/payment/consentSection'
import { ConsentDCASection } from 'e-submission/domain/data-model/payment/consentDCASection'
import { CheckStatusSection } from 'e-submission/domain/data-model/payment/EDACheckStatusSection'
import { EdaQrCodeSection } from 'e-submission/domain/data-model/payment/EdaQrCodeSection'

import { previewDocumentSection } from 'e-submission/domain/data-model/submit'
import { getSubmitWithoutPaymentField } from './submitWithoutPayment'
import paymentModalMergeState from './paymentModalMergeState'
import { isShowFirstPremium, shouldShowOptionsToPayLater } from './selectors'
import { getToggles } from 'quick-quote/feature-toggles'
import store from '../../../../store'
import { hasReceiptPaid, hasReceiptSigned } from '../selectors'
import { DCASection } from './DCASection'
import { cashDocumentSection } from 'e-submission/domain/data-model/payment/index_old'
import { getBasicPlanCode } from 'e-submission/domain/service'
import { documentEcbrNewName } from 'e-submission/utils/documents'
import { getWithExpiry, setWithExpiry } from 'e-submission/utils'

const mapWithKey = map.convert({ cap: false })

let basicPlanCodeCache = getWithExpiry('basicPlanCode') || []
let basicPlanCodePromise = null

export const shouldShowSubmitWithoutPaymentSection = (app) => {
  return getToggles().ENABLE_SUBMIT_WITHOUT_PAYMENT && allowToSubmitWithoutPayment(app)
}
export const evidentAttachmentOfPaymentReceiptText = ' (แนบหลักฐานการชำระเงิน)'
export const signedToTemporaryPaymentReceiptText = ' (ตรวจสอบใบรับเงินชั่วคราว)'
export const hasPaidReceiptAndDisappearedEvidence = function(app) {
  if (getToggles().ENABLE_QR_PAYMENT_STATUS) {
    return hasReceiptPaid(app) && !hasEvidenceUpload(app) && getSelectedReceiptEcbrStatus(app) === 'CREATED'
  }

  return hasReceiptPaid(app) && !hasEvidenceUpload(app)
}
export const noSignedReceiptAndAppearedEvidence = function(app) {
  return (
    !hasReceiptSigned(app) &&
    (hasEvidenceUpload(app) || (getToggles().ENABLE_QR_PAYMENT_STATUS && getSelectedReceiptEcbrStatus(app) === 'USED'))
  )
}
export const hasPaidReceiptButNoSignedReceipt = function(app) {
  return hasReceiptPaid(app) && !hasReceiptSigned(app)
}
export const decisionOfFirstPremiumCardTitle = function(app) {
  if (hasPaidReceiptAndDisappearedEvidence(app)) {
    return evidentAttachmentOfPaymentReceiptText
  } else if (noSignedReceiptAndAppearedEvidence(app)) {
    return signedToTemporaryPaymentReceiptText
  } else {
    return ''
  }
}

export const getFirstPremiumCardTitle = (app) => {
  const selectedReceiptType = getSelectedReceiptType(app)
  if (
    getToggles().ENABLE_CHANGE_PAY_IN_ATTACHMENT_STEP &&
    (selectedReceiptType === 'net bank' || selectedReceiptType === 'edc' || selectedReceiptType === 'credit card')
  ) {
    return decisionOfFirstPremiumCardTitle(app)
  } else if (getToggles().ENABLE_CHANGE_PAY_IN_ATTACHMENT_STEP && selectedReceiptType === 'cash') {
    if (hasPaidReceiptButNoSignedReceipt(app)) {
      return signedToTemporaryPaymentReceiptText
    } else {
      return ''
    }
  } else {
    if (hasPaidReceiptButNoSignedReceipt(app)) {
      return signedToTemporaryPaymentReceiptText
    } else if (hasReceiptSigned(app)) {
      return ' '
    } else {
      return ''
    }
  }
}

export const shouldEnableBrowseDocument = (app) =>
  (getToggles().ENABLE_ALLOW_BROWSE_ADDTIONAL_DOC && isRemoteSelling(app)) || undefined

export const checkedIconAtpSection = function(checkedFlowArray, app) {
  return overEvery(checkedFlowArray)(app)
}

export const mapSectionToArray = function(section, name, app, additionalProps) {
  return [section(name)(app, name, additionalProps)]
}

export function checkPaymentOptional(app) {
  if (!isQuickQuoteModelFactorMonthly(app)) return true

  // if (isATPPaid(app) || isATPSubmitted(app)) return true
  //! Important [2778] the requirement change only submitted ATP, then enable submit button
  if (isATPSubmitted(app)) return true

  if (isCCPAStatusCompleted(app) || isCCPAStatusError(app)) return true

  return false
}

function customTitleText(isToggleEdaOffOrConsentDA, isQrCodeState) {
  if (isToggleEdaOffOrConsentDA) {
    return isQrCodeState ? 'สแกน QR Code เพื่อดำเนินการสมัคร' : 'สมัครหักค่าเบี้ยประกันอัตโนมัติ ผ่านบัญชีธนาคาร'
  } else {
    return 'เงื่อนไขหักค่าเบี้ยประกันอัตโนมัติผ่านบัญชีธนาคาร'
  }
}

const isShowRelationshipDocument = (app) => {
  if (getToggles().ENABLE_CREDIT_CARD_RELATIONSHIP) {
    if (getToggles().ENABLE_ECBR_SYSTEMIZATION) {
      return isSignedEcbr(app) && isPayerOther(app)
    }
    return (
      isCreditCardRelationshipTier1(app) &&
      isFinishCreditCardPaymentSection(app) &&
      isSignedCreditCardPaymentSection(app)
    )
  }
}

function renderingComponent(app, isEnableBrowseFile, isShowATP, isShowCCPA, isShowAIUWResult, id) {
  // status submitted
  if (_.isEmpty(app)) {
    return []
  }
  const isAppSubmitted = _.get(app, 'status', '') === 'submitted'

  // The ATP is DA Form
  const newDaTitle = getToggles().ENABLE_EDA ? ' (DA Form)' : ''
  const atpForm = {
    id: 'ATP',
    c: 'MoreInfoCard',
    p: {
      subpage: 'atp',
      title: `สมัครหักค่าเบี้ยประกันอัตโนมัติ ผ่านบัญชีธนาคาร${newDaTitle}`,
      indentTitle: true,
      mergeState: (state, app, section) => {
        let dispatch
        let history
        if (section) {
          dispatch = section.dispatch
          history = section.history
        }

        const isConsentDAChecked = isAcceptConsentDA(app)
        const isEDAConsentChecked = isEDAConsent(app)
        const isToggleEdaOffOrConsentDA = !getToggles().ENABLE_EDA || isConsentDAChecked // toggle off or consentDA already
        const sections = isToggleEdaOffOrConsentDA
          ? mapSectionToArray(ATPSection, 'ATP', app)
          : mapSectionToArray(ConsentSection, 'consent', app)

        const isAppliedATP = isATPPaid(app) || isATPSubmitted(app) || isCheckStatusEDA(app)
        const isAppliedATPonline = getToggles().ENABLE_EDA && isAppliedATP && isFormTypeEDA(app)
        const checkedValidation = checkedIconAtpSection(
          [isATPPaid, isATPSubmitted, isSectionValid(state, sections)],
          app
        )
        const checked = getToggles().ENABLE_EDA ? isFormTypeDA(app) && checkedValidation : checkedValidation
        const readConsentEdaComplete = isConsentEdaComplete(state)
        const isOtherPaymentHasBeenMade = isAppliedATPonline || isCCPAStatusCompleted(app) || isCCPAStatusError(app)

        const isCheckStatusEDAPaid = getToggles().ENABLE_EDA && isATPPaid(app) && isFormTypeEDA(app)

        return {
          sections: sections,
          icon: checked ? 'check' : '',
          //! TODO: For 2566, we need to check if CCPA or eDA has been completed
          disabled: isOtherPaymentHasBeenMade,
          checked,
          paymentOptional: checkPaymentOptional(app),

          className: isToggleEdaOffOrConsentDA ? '' : 'eda-consent',
          isEdaConsent: true,
          customTitle: isToggleEdaOffOrConsentDA
            ? 'สมัครหักค่าเบี้ยประกันอัตโนมัติ ผ่านบัญชีธนาคาร'
            : 'เงื่อนไขหักค่าเบี้ยประกันอัตโนมัติผ่านบัญชีธนาคาร',
          customButtons: isToggleEdaOffOrConsentDA
            ? []
            : [
                {
                  text: 'ถัดไป',
                  visible: true,
                  disabled: !isEDAConsentChecked,
                  onClick: () => {
                    dispatch(updateConsentEdaTerms())
                  },
                },
              ],
          okButton: isCheckStatusEDAPaid ? {} : null,
        }
      },
    },
  }

  const renderAtpAndEda = () => {
    if (isShowATP && getToggles().ENABLE_EDA) {
      return [
        {
          id: 'EDA',
          c: 'MoreInfoCard',
          p: {
            subpage: 'eda',
            title: 'สมัครหักค่าเบี้ยประกันอัตโนมัติ ผ่านบัญชีธนาคารแบบออนไลน์',
            indentTitle: true,
            mergeState: (state, app, section) => {
              let dispatch
              let history
              if (section) {
                dispatch = section.dispatch
                history = section.history
              }

              const isConsentDAChecked = isAcceptConsentDA(app)
              const isEDAConsentChecked = isEDAConsent(app)

              let sections = mapSectionToArray(ATPSection, 'EDA', app)
              if (!isConsentDAChecked) {
                sections = mapSectionToArray(ConsentSection, 'consent', app)
              }
              const isShowCheckStatusPage = isCheckStatusEDA(app) // TODO: checkEDAStatus pending in process
              const _isShowingBayEdaQrCode = isShowingBayEdaQrCode(app) // TODO: checkEDAStatus pending in process
              if (_isShowingBayEdaQrCode) {
                sections = mapSectionToArray(EdaQrCodeSection, 'checkStatus', app)
              } else if (isShowCheckStatusPage) {
                sections = mapSectionToArray(CheckStatusSection, 'checkStatus', app)
              }

              const isAppliedATP = isATPPaid(app) || isATPSubmitted(app)
              const isAppliedATPpaper = getToggles().ENABLE_EDA && isAppliedATP && isFormTypeDA(app)
              const isAppliedATPonline = getToggles().ENABLE_EDA && isAppliedATP && isFormTypeEDA(app)
              const onlyViewEDASummaryInForm = isAppliedATPonline && isEDAViewFormOnly(state)

              if (onlyViewEDASummaryInForm) {
                // show ATP form but disable all input field also document upload
                sections = mapSectionToArray(ATPSection, 'EDA', app, { isViewOnly: true })
              }

              const checkedValidation = checkedIconAtpSection(
                [isATPPaid, isATPSubmitted, isSectionValid(state, sections)],
                app
              )
              const checked = getToggles().ENABLE_EDA ? isFormTypeEDA(app) && checkedValidation : checkedValidation
              const readConsentEdaComplete = isConsentEdaComplete(state)
              const isOtherPaymentHasBeenMade =
                isAppliedATPpaper || isCCPAStatusCompleted(app) || isCCPAStatusError(app)

              return {
                sections: sections,
                className: isConsentDAChecked ? '' : 'eda-consent',
                icon: checked ? 'check' : '',
                disabled: isOtherPaymentHasBeenMade,
                checked,
                paymentOptional: checkPaymentOptional(app),
                isEdaConsent: true,
                customTitle: customTitleText(isConsentDAChecked, _isShowingBayEdaQrCode),
                customButtons: isConsentDAChecked
                  ? []
                  : [
                      {
                        text: 'ถัดไป',
                        visible: true,
                        disabled: !isEDAConsentChecked,
                        onClick: () => {
                          dispatch(updateConsentEdaTerms())
                        },
                      },
                    ],
                isWarningEdaPaymentNeeded: true,
                okButton: _isShowingBayEdaQrCode
                  ? {
                      label: 'ยืนยัน',
                      disabled: false,
                      onClick: () => {
                        dispatch(setAppValue('ATP.isShowingBayEdaQrCode', false))
                        dispatch(setAppValue('ATP.checkStatusEDA', true))
                      },
                    }
                  : isShowCheckStatusPage
                  ? {}
                  : undefined, // for custom check status page show only back button on footer
                isViewOnly: onlyViewEDASummaryInForm,
              }
            },
          },
        },
        atpForm,
      ]
    } else if (isShowATP && !getToggles().ENABLE_EDA) {
      return [atpForm]
    } else {
      return []
    }
  }

  return [
    !isAppSubmitted &&
      createField(
        `submitWithoutPayment-${shouldShowOptionsToPayLater(app)}`,
        shouldShowSubmitWithoutPaymentSection(app) ? getSubmitWithoutPaymentField(app) : []
      ),
    !isAppSubmitted &&
      createField(
        `payment-${getFirstPremiumCardTitle(app)}`,
        compact([
          (!getToggles().ENABLE_SUBMIT_WITHOUT_PAYMENT || isShowFirstPremium(app)) && {
            id: 'payment',
            c: 'MoreInfoCard',
            p: {
              subpage: 'payment',
              title: `ชำระเบี้ยงวดแรก${getFirstPremiumCardTitle(app)}`,
              mergeState: paymentModalMergeState,
            },
          },
        ]),
        {
          marginTopLess: true,
          pl: [0, 0, 2],
          pr: [0, 0, 2],
        }
      ),
    !isAppSubmitted &&
      createField(
        `payment-optional`,
        compact([
          (isShowATP || isShowCCPA) && {
            id: 'QUICKLINK_MENU_TITLE',
            c: 'TitleCard',
            p: {
              title: 'ชำระเบี้ยงวดถัดไปอัตโนมัติ',
            },
          },
          ...renderAtpAndEda(),
          isShowCCPA && {
            id: 'CCPA',
            c: 'MoreInfoCard',
            p: {
              subpage: 'ccpa',
              title: 'สมัครหักค่าเบี้ยประกันอัตโนมัติ ผ่านบัตรเครดิต',
              indentTitle: true,
              mergeState: (state, app, section) => {
                let dispatch
                let history
                if (section) {
                  dispatch = section.dispatch
                  history = section.history
                }
                const sections = mapSectionToArray(CCPASection, 'CCPA', { ...app, dispatch }, section)
                const checked = isCCPAStatusCompleted(app) || isCCPAStatusError(app)
                const isDisable =
                  isATPPaid(app) || isATPSubmitted(app) || (getToggles().ENABLE_EDA && isCheckStatusEDA(app))
                return {
                  sections: sections,
                  icon: checked ? 'check' : '',
                  //! TODO: For 2566, we need to check if ATP or eDA has been completed
                  disabled: isDisable,
                  checked,
                  paymentOptional: checkPaymentOptional(app),
                  okButton: {
                    label: 'ยืนยัน',
                    disabled: !isCCPAStatusCompleted(app),
                    onClick: ({ toggleModal }) => {
                      toggleModal()
                    },
                  },
                  onClick: () => {
                    dispatch(setAppValue('CCPA.isSendingLink', false))

                    if (!has('CCPA.firstName')(app)) {
                      dispatch(createCCPADefaultValue(buildCCPADefaultValue(app)))
                    }
                  },
                }
              },
            },
          },
        ]),
        {
          marginTopLess: true,
          pl: [0, 0, 2],
          pr: [0, 0, 2],
        }
      ),
    !isAppSubmitted &&
      createField(
        'DCA',
        compact([
          isShowDCASelected(app) && {
            label: 'ลูกค้าประสงค์จะส่งหนังสือยินยอมขอรับ ผลประโยชน์ตามกรมธรรม์ ผ่านบัญชีธนาคาร (DCA) เมื่อใด',
            id: 'DCA.selected',
            c: 'RadioButtonWithDialog',
            required: true,
            p: {
              options: [
                {
                  text: 'มีความประสงค์',
                  value: true,
                  openDialog: false,
                },
                {
                  text: 'มีความประสงค์จะส่งเอกสารภายหลัง',
                  value: false,
                  openDialog: false,
                },
              ],
              onChange: ({ value, dispatch }) => {},
              subpage: 'DCA',
              title: 'ชำระเบี้ยงวดแรก',
            },
            mergeState: (state, app, { dispatch = noop, history } = {}) => {
              return {
                infoMessage:
                  getToggles().ENABLE_DCA_OPTIONS_INFO_MESSAGE && !isDCASelected(app)
                    ? 'กรณีที่ลูกค้าไม่ส่งหนังสือยินยอมขอรับ ผลประโยชน์ตามกรรมธรรม์ ผ่านบัญชีธนาคาร ทางบริษัทขอสงวนสิทธิ การนำส่งในรูปแบบ Cheque แทน'
                    : '',
              }
            },
          },
          isShowDCAForm(app) && {
            id: 'DCA.form',
            c: 'MoreInfoCard',
            p: {
              subpage: 'DCA',
              title: 'ยินยอมขอรับ ผลประโยชน์ตามกรมธรรม์ (DCA)',
              mergeState: (state, app, { dispatch = noop, history } = {}) => {
                const isConsentDCAChecked = isAcceptConsentDCA(app)
                const isDCAConsentChecked = isDCAConsent(app)

                let sections = [DCASection('dca-form')(app, id)]
                if (!isConsentDCAChecked) {
                  sections = mapSectionToArray(ConsentDCASection, 'consent', app)
                }

                const checked = isDCASigned(app)

                return {
                  sections: sections,
                  className: isConsentDCAChecked ? '' : 'dca-consent',
                  isDCAConsent: true,
                  customTitle: isConsentDCAChecked
                    ? 'ยินยอมขอรับ ผลประโยชน์ตามกรมธรรม์ (DCA)'
                    : 'ข้อกำหนดและเงื่อนไขการรับผลประโยชน์จากกรมธรรม์',
                  icon: checked ? 'check' : '',
                  onClick: () => {
                    const dca = getDCA(app)
                    if (_.isUndefined(_.get(dca, 'bank'))) {
                      dispatch(setDefaultDCA())
                    } else if (dca && !dca.dcaType && dca.status !== 'signed') {
                      //! If this conditions are met, we'll reset the app to new DCA flow
                      dispatch(setDefaultDCA())
                    }
                  },
                  checked,
                  customButtons: isConsentDCAChecked
                    ? []
                    : [
                        {
                          text: 'ถัดไป',
                          visible: true,
                          disabled: !isDCAConsentChecked,
                          onClick: () => {
                            dispatch(updateConsentDCATerms())
                          },
                        },
                      ],
                  okButton: undefined,
                }
              },
              infoMessage: getToggles().ENABLE_HIDE_DCA_MSG
                ? ''
                : 'กรุณาระบุบัญชีผู้เอาประกันภัยของ บมจ.ธนาคารกรุงไทย เท่านั้น',
            },
          },
        ]),
        {
          marginTopLess: true,
          pl: [0, 0, 2],
          pr: [0, 0, 2],
        }
      ),
    !isAppSubmitted &&
      isShowRelationshipDocument(app) &&
      createField(
        'credit',
        [
          {
            id: 'insured.creditCardRelationshipDocument',
            c: 'MoreInfoCard',
            p: {
              subpage: 'credit-card-relationship-doc',
              icon: 'illustrate',
              mergeState: (state) => {
                const documentType = get('insured.CREDIT_CARD_RELATIONSHIP_DOCUMENT', DOCUMENT_TYPE)
                const documentTypeName = get('name', documentType)
                const documentTypeText = get('text', documentType)

                const creditCardRelationshipDocumentList = getAllCreditCardRelationshipDocument(state)
                const totalCreditCardRelationshipDoc = size(creditCardRelationshipDocumentList)
                const maxCreditCardRelationshipDoc = 10

                const photoCardField = createField('insured.creditCardRelationshipDocument.documents', [
                  {
                    id: 'insured.creditCardRelationshipDocument.documents',
                    c: 'PhotoCard',
                    required: true,
                    p: {
                      isBrowseFile: isEnableBrowseFile,
                      mergeState: (state, app) => {
                        const creditCardRelationshipDocumentList = getAllCreditCardRelationshipDocument(state)
                        return {
                          value: mapWithKey(
                            (document, index) => ({
                              id: `insured.creditCardRelationshipDocument.documents[${index}]`,
                              name: get('name', document),
                              description: get('description', document),
                              checked: true,
                              editable: true,
                            }),
                            creditCardRelationshipDocumentList
                          ),
                        }
                      },
                    },
                  },
                ])
                const addPhotoCardField = createField('insured.creditCardRelationshipDocument.add', [
                  {
                    id: 'insured.creditCardRelationshipDocument.add',
                    c: 'PhotoCard',
                    required: false,
                    p: {
                      isBrowseFile: isEnableBrowseFile,
                      mergeState: (state, app, { dispatch = noop } = {}) => {
                        const creditCardRelationshipDocumentList = getAllCreditCardRelationshipDocument(state)
                        const totalCreditCardRelationshipDoc = size(creditCardRelationshipDocumentList)
                        const description = flow(getFiles, get([documentTypeName, 'description']))(state)
                        return {
                          description,
                          disabled: isEmpty(description),
                          value:
                            totalCreditCardRelationshipDoc < maxCreditCardRelationshipDoc
                              ? [
                                  {
                                    id: `insured.creditCardRelationshipDocument.documents[${totalCreditCardRelationshipDoc}]`,
                                    name: documentTypeName,
                                    checked: false,
                                    editable: true,
                                    placeholder: 'กรุณากรอกข้อมูล',
                                    onChange: (value) => {
                                      dispatch(
                                        addFileProps(documentTypeName, {
                                          description: value,
                                        })
                                      )
                                    },
                                  },
                                ]
                              : [],
                        }
                      },
                    },
                  },
                ])
                const placeHolderFields = times((index) =>
                  createField(`insured.creditCardRelationshipDocument.placeHolder[${index}]`, [
                    {
                      id: `insured.creditCardRelationshipDocument.placeHolder[${index}]`,
                      c: 'PlaceHolderCard',
                    },
                  ])
                )(maxCreditCardRelationshipDoc - totalCreditCardRelationshipDoc - 1)
                const checked = isCreditCardRelationshipDocumentNotEmpty(state)

                return {
                  title: `${documentTypeText}`,
                  icon: checked ? 'check' : 'illustrate',
                  sections: [
                    createSection(
                      compact([
                        size(creditCardRelationshipDocumentList) > 0 && photoCardField,
                        addPhotoCardField,
                        ...placeHolderFields,
                      ])
                    ),
                  ],
                }
              },
            },
          },
        ],
        {
          marginTopLess: true,
          pl: [0, 0, 2],
          pr: [0, 0, 2],
        }
      ),
    createField(
      'document',
      compact([
        hasReceiptSigned(app) &&
          getSelectedReceiptType(app) === 'cash' &&
          getToggles().ENABLE_CHANGE_PAY_IN_ATTACHMENT_STEP && {
            id: 'bankSlip',
            c: 'MoreInfoPhotoCard',
            p: {
              isBrowseFile: isEnableBrowseFile,
              mergeState: (state, app, { dispatch = noop } = {}) => {
                const id = 'receipts[0]'
                const documentSection = cashDocumentSection(id)(app, id)
                const receipt = get(id, app)
                const receiptNo = getReceiptNo(receipt)
                const documentType = getReceiptDocumentType(receipt)
                const documentTypeName = documentEcbrNewName(documentType.name, receiptNo)
                const isSigned = hasReceiptSigned(app)
                const isUploaded = overEvery([
                  has(['_attachments', documentTypeName]),
                  isSectionValid(state, [documentSection]),
                ])(app)
                return {
                  onOk: () => {
                    if (isUploaded) {
                      dispatch(updateReceipt(id, documentTypeName))
                      return true
                    } else {
                      dispatch(validateApplication())
                      return false
                    }
                  },
                  value: [
                    {
                      icon: isUploaded ? 'check' : '',
                      sections: [documentSection],
                      name: documentTypeName,
                      title: 'ถ่ายรูปใบนําฝากเงินจาก ธนาคาร',
                      description: 'แนบหลักฐานการชำระเงิน',
                      checked: isUploaded,
                      disabled: !isSigned,
                    },
                  ],
                }
              },
            },
          },
        {
          id: 'document',
          c: 'MoreInfoCard',
          p: {
            subpage: 'preview-document',
            title: 'เรียกดูเอกสารที่ลงนามเรียบร้อย',
            sections: [previewDocumentSection('preview-document')(app)],
          },
        },
        !isAppSubmitted && {
          id: 'insured.additionalDocument',
          c: 'MoreInfoCard',
          p: {
            subpage: 'additional-document',
            icon: 'illustrate',
            mergeState: (state) => {
              const documentType = get('insured.ADDITIONAL_DOCUMENT', DOCUMENT_TYPE)
              const documentTypeName = get('name', documentType)
              const documentTypeText = get('text', documentType)

              const additionalDocumentList = getAllAdditionalDocument(state)
              const totalAdditionalDoc = size(additionalDocumentList)
              const maxAdditionalDoc = 10

              const photoCardField = createField('insured.additionalDocument.documents', [
                {
                  id: 'insured.additionalDocument.documents',
                  c: 'PhotoCard',
                  required: true,
                  p: {
                    isBrowseFile: isEnableBrowseFile,
                    mergeState: (state, app) => {
                      const additionalDocumentList = getAllAdditionalDocument(state)
                      return {
                        value: mapWithKey(
                          (document, index) => ({
                            id: `insured.additionalDocument.documents[${index}]`,
                            name: get('name', document),
                            description: get('description', document),
                            checked: true,
                            editable: true,
                          }),
                          additionalDocumentList
                        ),
                      }
                    },
                  },
                },
              ])
              const addPhotoCardField = createField('insured.additionalDocument.add', [
                {
                  id: 'insured.additionalDocument.add',
                  c: 'PhotoCard',
                  required: false,
                  p: {
                    isBrowseFile: isEnableBrowseFile,
                    mergeState: (state, app, { dispatch = noop } = {}) => {
                      const additionalDocumentList = getAllAdditionalDocument(state)
                      const totalAdditionalDoc = size(additionalDocumentList)
                      const description = flow(getFiles, get([documentTypeName, 'description']))(state)

                      return {
                        description,
                        disabled: isEmpty(description),
                        value:
                          totalAdditionalDoc < maxAdditionalDoc
                            ? [
                                {
                                  id: `insured.additionalDocument.documents[${totalAdditionalDoc}]`,
                                  name: documentTypeName,
                                  checked: false,
                                  editable: true,
                                  placeholder: 'กรุณากรอกข้อมูล',
                                  onChange: (value) => {
                                    dispatch(
                                      addFileProps(documentTypeName, {
                                        description: value,
                                      })
                                    )
                                  },
                                },
                              ]
                            : [],
                      }
                    },
                  },
                },
              ])
              const placeHolderFields = times((index) =>
                createField(`insured.additionalDocument.placeHolder[${index}]`, [
                  {
                    id: `insured.additionalDocument.placeHolder[${index}]`,
                    c: 'PlaceHolderCard',
                  },
                ])
              )(maxAdditionalDoc - totalAdditionalDoc - 1)

              return {
                title: `${documentTypeText} (ถ้ามี)`,
                sections: [
                  createSection(
                    compact([
                      size(additionalDocumentList) > 0 && photoCardField,
                      !isAppSubmitted && addPhotoCardField,
                      ...placeHolderFields,
                    ])
                  ),
                ],
              }
            },
          },
        },
      ]),
      {
        marginTopLess: true,
        pl: [0, 0, 2],
        pr: [0, 0, 2],
      }
    ),
    !isAppSubmitted &&
      isShowAIUWResult &&
      createField(`AIUW.Acknowledge`, [
        {
          id: `AIUW.Acknowledge`,
          c: 'AiUwCheckbox',
          p: {
            mergeState: (state) => {
              const app = getCurrentApp(state)
              return {
                disabled: !isAIUWFinished(state),
              }
            },
            children: 'รับทราบสถานะการพิจารณาใบคำขอเบื้องต้น',
            className: 'ai-underwriting-checkbox',
            isAttachedIcon: true,
          },
        },
      ]),
    !isAppSubmitted &&
      isShowAIUWResult &&
      createField(``, [
        {
          id: `${id}.name`,
          c: 'NotificationCard',
          p: {
            mergeState: (state) => {
              const app = getCurrentApp(state)
              const AIUWPolicyStatus = getAIUWPolicyStatus(app)
              const AIUW = getAIUW(app)
              const isPaid = AIUW.completedPaid
              let message = 'อยู่ระหว่างส่งพิจารณาใบคำขอเบื้องต้น'
              let remarkMessage = 'กรุณาทำรายการชำระเงินให้เรียบร้อยเพื่อดูผลการพิจารณาเบื้องต้น'

              const DEFAULT_REMARK_MESSAGE =
                'เป็นผลการพิจารณาเบื้องต้นเท่านั้นยังไม่เป็นที่สิ้นสุดเพื่อเป็นข้อมูลสำหรับตัวแทนในการจัดเตรียมเอกสารประกอบการพิจารณารับประกันชีวิต'

              if (AIUW && AIUW.status === 'requesting') {
                remarkMessage = ''
                message = '...'
              } else if (AIUW && AIUW.status !== 'requested') {
                if (isPaid && AIUWPolicyStatus == 'STP') {
                  message = 'ผ่านการพิจารณาเบื้องต้น'
                  remarkMessage = DEFAULT_REMARK_MESSAGE
                } else if (isPaid && AIUWPolicyStatus == 'RUW') {
                  message = 'รอการพิจารณา'
                  remarkMessage = DEFAULT_REMARK_MESSAGE
                } else if (!isPaid && AIUWPolicyStatus == 'STP') {
                  message = 'ได้รับการพิจารณาเบื้องต้นและรอการชำระเบี้ย'
                  remarkMessage = DEFAULT_REMARK_MESSAGE
                } else if (!isPaid && AIUWPolicyStatus == 'RUW') {
                  message = 'รอการพิจารณาและรอการชำระเบี้ย'
                  remarkMessage = DEFAULT_REMARK_MESSAGE
                } else {
                  message = 'UNKNOWN_ERROR'
                }
              } else {
                remarkMessage = 'กรุณาทำรายการชำระเงินให้เรียบร้อยเพื่อดูผลการพิจารณาเบื้องต้น'
              }

              // MRTA category contain product MART & GLSTP for Banca user
              const _isMRTACategory = isMRTACategory(app)
              const insuredHeightAndWeight = getInsuredHeightAndWeight(state)
              const bmiValue = calculateBMI(insuredHeightAndWeight[1], insuredHeightAndWeight[0])
              const isBMInormal = inRange(17, 32, bmiValue) || isEqual(17, bmiValue) || isEqual(32, bmiValue)

              return {
                value: message,
                title: 'สถานะพิจารณาใบคำขอเบื้องต้น',
                resultMessage: message,
                remarkMessage,
                requestStatus: AIUW.status,
                resultMemo: AIUW.result?.data?.AIUWMemos || [],
                isMRTACategory: _isMRTACategory,
                isBMInormal,
              }
            },
          },
        },
      ]),
    !isAppSubmitted &&
      createField('insured.submitApplication', [
        {
          id: 'insured.submitApplication',
          c: 'Button',
          p: {
            mergeState: (state, app, { dispatch, history }) => {
              return {
                disabled: !canSubmit(state),
                onClick: () => {
                  dispatch(sendApplication(history))
                },
              }
            },
            children: 'ส่งใบคำขอ',
            block: true,
            icon: 'wifi',
            style: {
              fontSize: '1.175rem',
              marginTop: '40px',
            },
          },
        },
      ]),
    !isAppSubmitted &&
      createField(
        'insured.submitApplicationDiscliamer',
        [
          {
            id: 'insured.submitApplicationDiscliamer',
            c: 'MutedText',
            p: {
              children: 'กรุณาต่อ Internet เพื่อส่งใบคำขอ',
            },
          },
        ],
        {
          style: {
            marginTop: '-1rem',
            textAlign: 'center',
          },
        }
      ),
  ]
}

function getQuestion(app, id, { dispatch, history }) {
  const basicPlanCode = basicPlanCodeCache
  if (basicPlanCode.length === 0 && !basicPlanCodePromise) {
    basicPlanCodePromise = getBasicPlanCode().then((data) => {
      if (Array.isArray(data)) {
        basicPlanCodeCache = data.map((o) => o.planCode)
        setWithExpiry('basicPlanCode', basicPlanCodeCache, 3600000)
      }

      return basicPlanCodeCache
    })
  }
  const isShowCCPA = getToggles().ENABLE_CCPA_SUBSCRIPTION && isAppEligibleToDoCCPA(app, basicPlanCode)
  const isShowATP =
    hasATP(app) &&
    (getToggles().ENABLE_SUBMIT_WITHOUT_PAYMENT ||
      !allowToSubmitWithoutPayment(app) ||
      (allowToSubmitWithoutPayment(app) && isSelectedToPayNow(app)))
  const isEnableBrowseFile = shouldEnableBrowseDocument(app)
  const isShowAIUWResult = getToggles().ENABLE_AIUW && getAIUW(app)
  return compact(renderingComponent(app, isEnableBrowseFile, isShowATP, isShowCCPA, isShowAIUWResult, id))
}

export default createSectionCreator(getQuestion)
